import styled from '@emotion/styled'

import { StyledVerifyAccountModal } from '../VerifyAccountModal'

export const StyledCheckYourEmailModal = styled(StyledVerifyAccountModal)``
